module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-center bg-tela-login"
  }, [_c('div', {
    staticClass: "middle-white-box"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "not-found-img",
    attrs: {
      "src": _vm.imageNotFound
    }
  }), _c('br'), _c('p', {
    staticClass: "big-txt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('naoAutorizado.labels.mensagem'))
    }
  }), _c('button-primary', {
    attrs: {
      "label": _vm.$t('naoAutorizado.labels.voltarHome'),
      "faIcon": "",
      "id": "btn403VoltarHome",
      "clickFunction": _vm.goHome,
      "customClass": "big-primary"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eb2dd9ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb2dd9ec"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/unauthorized/unauthorized.pug
// module id = 1467
// module chunks = 0